import React, {useEffect, useState} from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Typography,
    Box, MenuItem, CircularProgress, Stepper, Step, StepLabel, Grid, Autocomplete, FormControlLabel, Checkbox
} from '@mui/material';
import {
    cadastraRetirada,
    cadastraRetiradaExtra,
    getRetiradasStatics,
    listaProdutos,
    saldoColaborador
} from "../../products/configs/functions";
import {
    getPessoa,
    listaUsuarios,
    listaUsuariosFilter,
    validarFacial
} from "../../../management/people/configs/functions";
import {useCommonItems} from "../../../../../contexts/CommonItensProvider";
import {NewRequisicaoFirstStep} from "./NewRequisicaoFirstStep";
import {NewRequisicaoThirdStep} from "./NewRequisicaoThirdStep";
import {NewRequisicaoFourthStep} from "./NewRequisicaoFourthStep";
import {listaJustificativaRequisicao} from "../../guidelines/config/functions";
import {useAppContext} from "../../../../../contexts/AppContext";
import {NewRequisicaoSecondStep} from "./NewRequisicaoSecondStep";

const StepHeader = ({ steps, activeStep }) => {
    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="h6">Registro</Typography>
            <Typography variant="body2" color="textSecondary">
                Faça o procedimento com atenção.
            </Typography>
            <Stepper activeStep={activeStep} alternativeLabel sx={{ mt: 2 }}>
                {steps.map((label, index) => (
                    <Step key={index}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>
        </Box>
    );
};

export function NewRequisicaoDialog({
                                        open,
                                        onClose,
                                        selectedIdEmpresa,
                                        selectedEmpresa,
                                        tipoRequisicao,
                                        pessoas,
                                        equipamentos
                                    }) {
    const { dadosUsuario } = useAppContext();
    const { exibirAlerta, exibirDialog, handleCloseDialog } = useCommonItems();

    const [step, setStep] = useState(1);

    const [isLoading, setIsLoading] = useState(false);

    const [biometriaSrc, setBiometriaSrc] = useState(null);
    const [firtBiometriaSrc, setFirtBiometriaSrc] = useState(null);
    const [isAllowedCapture, setIsAllowedCapture] = useState(false);
    const [validFacial, setValidFacial] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [isFirstAccess, setIsFirstAccess] = useState(false);

    const [selectedPessoa, setSelectedPessoa] = useState(null);
    const [selectedEquipamento, setSelectedEquipamento] = useState(null);

    const [produtos, setProdutos] = useState({});
    const [produtosSelecionados, setProdutosSelecionados] = useState([]);

    const [justificativas, setJustificativas] = useState({});
    const [selectedJustificativa, setSelectedJustificativa] = useState(null);

    const [marcarEntregue, setMarcarEntregue] = useState(false);
    const [password, setPassword] = useState(null);

    const [nextStep, setNextStep] = useState(false);

    const steps = [
        'Identificação geral',
        'Confirmação de identidade',
        'Escolha de EPI\'s',
        'Confirmação'
    ];

    const handleClose = (event, reason) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            setStep(1);
            onClose();

            setSelectedPessoa(null);
            setIsAllowedCapture(false);
            setSelectedJustificativa(null)
            setValidFacial(false);
            setProdutosSelecionados([]);
            setIsFirstAccess(false);
        }
    };

    const handleNext = () => setStep(step + 1);
    const handleBack = () => setStep(step - 1);

    async function handleSubmit () {
        let sucesso = false;
        try {
            setIsLoading(true);
            exibirDialog('Registrando...');

            if (tipoRequisicao === 'retirada') {
                const produtos = produtosSelecionados.map((p) => ({
                    id_produto: p.variacaoSelecionada || p.produto.id,
                    qtd_produto: p.quantidadeSelecionada
                }));

                const data = {
                    id_empresa: selectedPessoa.empresa.id,
                    matricula: selectedPessoa.matricula,
                    produtos,
                    tipo_autenticacao: validFacial ? 'biometria' : password != null ? 'senha' : 'responsavel',
                    face_biometric_photo: validFacial && biometriaSrc ? biometriaSrc : null
                };

                if (selectedEquipamento && selectedEquipamento.id && selectedEquipamento.id !== 0) {
                    data.id_equipamento = selectedEquipamento.id;
                }

                await cadastraRetirada(data);
            } else if (tipoRequisicao === 'extra') {
                for (const produto of produtosSelecionados) {
                    const data = {
                        id_empresa: selectedPessoa.empresa.id,
                        matricula: selectedPessoa.matricula,
                        id_produto: produto.variacaoSelecionada || produto.produto.id,
                        id_justificativa_requisicao: produto.justificativaSelecionada,
                        quantidade: 1,
                        tipo_autenticacao: validFacial ? 'biometria' : password != null ? 'senha' : 'responsavel',
                        face_biometric_photo: validFacial && biometriaSrc ? biometriaSrc : null,
                        entregue: produto.marcarComoEntregue
                    };

                    if (selectedEquipamento && selectedEquipamento.id && selectedEquipamento.id !== 0) {
                        data.id_equipamento = selectedEquipamento.id;
                    }

                    await cadastraRetiradaExtra(data);
                }
            }

            sucesso = true;
            handleClose();
        } catch (error) {
            const msg = error?.response?.data?.erro || 'Ocorreu um erro ao registrar requisição';
            exibirAlerta('Ops', msg, 'error');
        } finally {
            setIsLoading(false);
            handleCloseDialog();

            if (sucesso) {
                exibirAlerta('Sucesso', 'Requisição realizada com sucesso!', 'success');
                handleClose();
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            }
        }
    }

    async function getSaldo() {
        try {
            setIsLoading(true);

            if (tipoRequisicao === 'retirada') {
                const res = await saldoColaborador({ id_empresa: selectedIdEmpresa, matricula: selectedPessoa?.matricula });
                setProdutos(res.data.saldo_epis);
            } else {
                const res = await listaProdutos({ id_empresa: selectedIdEmpresa, isFilter: true });
                const adapter = res.data.data.map((item) => ({
                    produto: item,
                    qtd_disponivel: item.qtd_disponivel ?? item.quantidade_maxima ?? 0,
                }));
                setProdutos(adapter);
            }
        } catch (error) {
            exibirAlerta('Ops', 'Ocorreu um erro ao carregar os produtos', 'error');
        } finally {
            setIsLoading(false);
        }
    }

    async function getJustificativas() {
        try {
            setIsLoading(true);

            const res = await listaJustificativaRequisicao({ id_empresas: [selectedIdEmpresa], isFilter: true });
            setJustificativas(res.data.data);
        } catch (error) {
            exibirAlerta('Ops', 'Ocorreu um erro ao carregar os justificativas', 'error');
        } finally {
            setIsLoading(false);
        }
    }

    async function checkFacial() {
        try {
            exibirDialog('Validando facial...');

            const res = await validarFacial(selectedPessoa.id, biometriaSrc);
            if (res.data.status === 200) {
                setValidFacial(true);
                setPassword(false);
                exibirAlerta('Sucesso', 'Facial validada com sucesso', 'success');
            } else {
                setValidFacial(false);
                setPassword(true);
                exibirAlerta('Erro', 'Facial não validada', 'error');
            }
        } catch (error) {
            setValidFacial(false);
            setPassword(true);
            exibirAlerta('Ops', 'Erro ao validar facial', 'error');
        } finally {
            handleCloseDialog();
        }
    }

    useEffect(() => {
        if (selectedPessoa && !selectedPessoa.isDetailed) {
            const fetchData = async () => {
                try {
                    let pessoaCompleta = await getPessoa(selectedPessoa.id, true);
                    pessoaCompleta = pessoaCompleta?.data;
                    setSelectedPessoa({ ...pessoaCompleta, isDetailed: true });
                } catch (e) {
                    console.error("Erro ao buscar pessoa completa", e);
                }
            };

            fetchData();
        }
    }, [selectedPessoa]);

    useEffect(() => {
        if (selectedIdEmpresa && open) {
            if (step === 2) getSaldo(); if (tipoRequisicao === 'extra') getJustificativas();
        }
    }, [selectedIdEmpresa, open, step]);

    useEffect(() => {
        if (selectedPessoa) {
            setIsFirstAccess(selectedPessoa.primeiroAcesso);
        }

        if (selectedPessoa && selectedPessoa.biofaceIdentifier) {
            setIsAllowedCapture(true);
            setFirtBiometriaSrc(selectedPessoa.biofaceIdentifier);
            setBiometriaSrc(selectedPessoa.biofaceIdentifier);
        } else {
            setIsAllowedCapture(false);
            setBiometriaSrc(null);
        }
    }, [selectedPessoa]);

    useEffect(() => {
        if (selectedPessoa && (firtBiometriaSrc !== biometriaSrc && biometriaSrc != null)) checkFacial();
    }, [biometriaSrc]);

    useEffect(() => {
        if (!produtosSelecionados.length){ setIsDisabled(true); return; }

        if (tipoRequisicao === 'retirada') {
            if (produtosSelecionados.some(
                (p) => p.produto.filhos?.length > 0 && !p.variacaoSelecionada
            )) {setIsDisabled(true); return;}
        } else if (tipoRequisicao === 'extra') {
            if (produtosSelecionados.length === 0 ||
                !selectedJustificativa) {setIsDisabled(true); return;}
        }

        setIsDisabled(false);
    }, [tipoRequisicao, produtosSelecionados, selectedJustificativa]);

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth='lg'>
            <StepHeader steps={steps} activeStep={step - 1} />

            {step === 1 && (
                <>
                    <DialogTitle>Identificação de colaborador</DialogTitle>
                    <DialogContent justifyContent="center" >
                        <NewRequisicaoFirstStep
                            isLoading={isLoading}
                            pessoas={pessoas}
                            equipamentos={equipamentos}
                            selectedPessoa={selectedPessoa}
                            setSelectedPessoa={setSelectedPessoa}
                            selectedEquipamento={selectedEquipamento}
                            setSelectedEquipamento={setSelectedEquipamento}
                            selectedEmpresa={selectedEmpresa}
                            biometriaSrc={biometriaSrc}
                            setBiometriaSrc={setBiometriaSrc}
                            isAllowedCapture={isAllowedCapture}
                            setIsAllowedCapture={setIsAllowedCapture}
                            password={password}
                            setPassword={setPassword}
                            validFacial={validFacial}
                            nextStep={nextStep}
                            setNextStep={setNextStep}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} variant="outlined">Cancelar</Button>
                        <Button onClick={handleNext} disabled={!selectedPessoa || (!nextStep)} variant="contained" color="primary">Continuar</Button>
                    </DialogActions>
                </>
            )}

            {step === 2 && (
                <>
                    <DialogContent justifyContent="center" >
                        <NewRequisicaoSecondStep
                            selectedPessoa={selectedPessoa}
                            biometriaSrc={biometriaSrc}
                            setBiometriaSrc={setBiometriaSrc}
                            isAllowedCapture={isAllowedCapture}
                            setIsAllowedCapture={setIsAllowedCapture}
                            isFirstAccess={isFirstAccess}
                            password={password}
                            setPassword={setPassword}
                            validFacial={validFacial}
                            setValidFacial={setValidFacial}
                            nextStep={nextStep}
                            setNextStep={setNextStep}
                            reloadPessoa={() => setSelectedPessoa({ ...selectedPessoa, isDetailed: false })}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} variant="outlined">Cancelar</Button>
                        <Button onClick={handleBack} variant="outlined">Voltar</Button>
                        <Button
                            onClick={handleNext}
                            disabled={!nextStep}
                            variant="contained"
                            color="primary"
                        >
                            Continuar
                        </Button>
                    </DialogActions>
                </>
            )}

            {step === 3 && (
                <>
                    <DialogContent justifyContent="center" >
                        <NewRequisicaoThirdStep
                            isLoading={isLoading}
                            produtos={produtos}
                            produtosSelecionados={produtosSelecionados}
                            setProdutosSelecionados={setProdutosSelecionados}
                            tipoRequisicao={tipoRequisicao}
                            justificativas={justificativas}
                            selectedJustificativa={selectedJustificativa}
                            setSelectedJustificativa={setSelectedJustificativa}
                            marcarEntregue={marcarEntregue}
                            setMarcarEntregue={setMarcarEntregue}
                            selectedPessoa={selectedPessoa}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} variant="outlined">Cancelar</Button>
                        <Button onClick={handleBack} variant="outlined">Voltar</Button>
                        <Button
                            onClick={handleNext}
                            disabled={
                                produtosSelecionados.length <= 0 ||
                                (tipoRequisicao === 'extra' && produtosSelecionados.some(p => !p.justificativaSelecionada)) ||
                                (tipoRequisicao !== 'extra' && produtosSelecionados.some(p => !p.variacaoSelecionada))
                            }
                            variant="contained"
                            color="primary"
                        >
                            Confirmar
                        </Button>
                    </DialogActions>
                </>
            )}

            {step === 4 && (
                <>
                    <DialogContent justifyContent="center" >
                        <NewRequisicaoFourthStep
                            colaborador={selectedPessoa}
                            produtosSelecionados={produtosSelecionados}
                            tipoRequisicao={tipoRequisicao}
                            selectedJustificativa={selectedJustificativa}
                            marcarComoEntregue={marcarEntregue}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} variant="outlined">Cancelar</Button>
                        <Button onClick={handleBack} variant="outlined">Voltar</Button>
                        <Button onClick={handleSubmit} variant="contained" color="primary">Confirmar</Button>
                    </DialogActions>
                </>
            )}
        </Dialog>
    );
}
